module.exports = __webpack_public_path__ + "static/img/default9-16.58a632da.png";